import { DESKTOP_SIDEBAR_WIDTH_VALUE } from 'modules/missionControl/constants';

export const ACTION_TYPE_TO_DISPLAY_TEXT_MAP: Record<string, string> = {
  updated: 'Edited',
  created: 'Created',
  // Not currently supported for Homepage alpha
  pageView: 'Viewed',
};

export const ACTIVITY_ITEM_TEST_IDS = {
  ITEM: 'activity-item',
  THUMBNAIL: 'activity-item-thumbnail',
  ITEM_NAME: 'activity-item-name',
  ITEM_TYPE: 'activity-item-type',
  ACTION_TYPE: 'activity-item-action-type',
  MEDIUM_ICON: 'activity-item-icon',
};

export const TEMPLATE_THUMBNAIL_QUERY_KEY = 'homepageTemplatePreview';

export const CAMPAIGN_METADATA_ICON_SIZE = { height: 12, width: 12 };

export const MAX_ITEM_TITLE_WIDTH = DESKTOP_SIDEBAR_WIDTH_VALUE * 0.62;
